// extracted by mini-css-extract-plugin
module.exports = {"visually-hidden":"BackButton_visually-hidden__KMCIM","container":"BackButton_container__jS_Tc","base-content":"BackButton_base-content__P4nrk","root":"BackButton_root__fLlzL"};